Hop.defineModule('supportCatchMail', (root, param) => {
    const $root = $(root);
    const emailFieldPopup = $('#signupModal').find('input[name = email]');

    function getFormData($form) {
        const unindexedArray = $form.serializeArray();
        const indexedArray = {};

        $.map(unindexedArray, (n) => {
            indexedArray[n['name']] = n['value'];
        });

        return indexedArray;
    }

    $root.submit((e) => {
        e.preventDefault();
        const email = $root.find('input[name = email]').val();

        emailFieldPopup.val(email);

        $.ajax({
            method: 'POST',
            url: $root.attr('action'),
            data: JSON.stringify(getFormData($root)),
            datatype: 'json',
            contentType: 'application/json; charset=utf-8',
        }).done(() => {
            Hop.safeGA('send', 'event', 'catchmail', 'TOTAL', 'Total');
            Hop.safeGA('send', 'event', 'catchmail', 'inscription', param.gaTagName);
            Hop.connect.control.showSigninPopup($root.find('button[type="submit"]'));
        });
    });
});
